/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import { arrayOf, oneOf, elementType, func, object, shape, string, number, any, } from 'prop-types';
const filterSlots = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
};
const defaultSlot = filterSlots.LEFT;
const renderFilters = ({ filters, controls }) => filters.map(({ name, Component }) => controls[name] && (React.createElement(Component, { key: name, value: controls[name].value, onChange: (v) => controls[name].onChange(v) })));
const TableFilters = ({ filters, controls }) => {
    const filtersBySlot = useMemo(() => filters?.reduce((acc, filter) => {
        const slot = filter.slot || defaultSlot;
        acc[slot].push(filter);
        return acc;
    }, {
        [filterSlots.LEFT]: [],
        [filterSlots.RIGHT]: [],
    }), [filters]);
    if (!filters?.length) {
        return null;
    }
    return (React.createElement("div", { className: "b-twf__filters" },
        React.createElement("div", { className: "b-twf__filters-left-slot" }, renderFilters({ filters: filtersBySlot[filterSlots.LEFT], controls })),
        React.createElement("div", { className: "b-twf__filters-right-slot" }, renderFilters({ filters: filtersBySlot[filterSlots.RIGHT], controls }))));
};
TableFilters.filterSlots = filterSlots;
TableFilters.propTypes = {
    filters: arrayOf(shape({
        name: string.isRequired,
        Component: elementType.isRequired,
        componentProps: object,
        transform: func,
        throttle: number,
        initialValue: any,
        slot: oneOf(Object.values(filterSlots)), // default "LEFT"
    })),
    controls: object,
};
TableFilters.defaultProps = {
    filters: undefined,
    controls: undefined,
};
export default TableFilters;
